import { ca } from '@cian/analytics';

export function trackReliableLabelClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'tab_reliable_dev',
    useLastProducts: true,
  });
}

export function trackEscrowLabelClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'tab_escrow',
    useLastProducts: true,
  });
}
